export default {
  fullLevel: '/clientEcosys/courierLevel/allLevel'
}
